export function setPopupMenu(status) {
  return dispatch => {
    dispatch({
      type: "SET_POPUP_MENU",
      data: status
    });
  }
}
export function setStoragePoup(status) {
  return dispatch => {
    dispatch({
      type: "SET_STORAGE_POP",
      data: status
    })
  }
}
export function setDialog(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DIALOG",
      data: status
    });
  }
}
export function setServiceComboItemsPop(status) {
  return dispatch => {
    dispatch({
      type: "SET_SERVICE_CMB_POP",
      data: status
    })
  }
}
export function setSelectStaffPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_SELECTSTAFF_POPUP",
      data: status
    });
  }
}
export function setSelectCostCenterPopup(status) {
  return dispatch => {
    dispatch({
      type: "SET_SELECT_COSTCENTER_POPUP",
      data: status
    });
  }
}
export function setSelectProductGroupPop(status) {
  return dispatch => {
    dispatch({
      type: "SET_SELECT_PRODUCTGROUP_POP",
      data: status
    })
  }
}